module.exports = __webpack_public_path__ + "img/vmware-logo-grey.5c9156b9.svg";